import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinusSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMinusSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M6 11.25H18V12.75H6V11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMinusSmall;
